module.exports = __webpack_public_path__ + "static/media/coaching.11b81abe.png";